<template lang="html">
  <div
    class="load-center-mask dis-f align-center justify-center"
    v-if="showErrorInfo"
  >
    <span
      class="loading-text fs-14 c-white text-center paddingh40 paddingv15"
      v-html="info"
    ></span>
  </div>
</template>

<script>
import Vue from "vue";
var eventHub = new Vue();
Vue.prototype.toast = (txt) => {
  eventHub.$emit("toast", txt);
  setTimeout(() => {
    eventHub.$emit("hidetToast");
  }, 1500);
};
export default {
  name: "Toast",
  data: () => ({
    showErrorInfo: false,
    info: "",
    type: "",
  }),
  created() {
    eventHub.$on("toast", (txt) => {
      this.info = txt;
      this.showErrorInfo = true;
    });
    eventHub.$on("hidetToast", () => {
      this.info = "";
      this.showErrorInfo = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.load-center-mask {
  position: fixed;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.2);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity 0.3s;
  .loading-text {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.75);
    margin: auto;
  }
}
</style>
